interface Validator {
  name: string;
  validator: any;
  message: string;
}
interface Option {
  value: any;
  name: string;
}
// export interface ControlCondition { key: any; value: any; }

interface BaseConfig {
  label?: string;
  dateRangeFirstLabel?: string;
  dateRangeLastLabel?: string;
  key?: string;
  dateRangeFirstKey?: string;
  dateRangeLastKey?: string;
  hint?: string;
  inputType?: string;
  options?: Option[] | any;
  collections?: any;
  type: FieldType;
  searchParameters?: string[];
  value?: any;
  disabled?: boolean;
  visible?: boolean;
  minDate?: Date;
  maxDate?: Date;
  multiple?: boolean;
  showWhen?: string;
  hideRequiredMarker?: boolean;
  rowClass?: 'small' | 'medium' | 'large';
  validations?: Validator[];
  acceptType?: string;
  filterValueKey?: string;
  filterKey?: string;
  dateFormat?: string;
  showCancel?: boolean;
  useObservable?: boolean;
  removeUnderscore?: boolean;
  color?: 'primary' | 'accent' | 'warn';
}

interface DefaultQUestions extends BaseConfig {
  type:
    | FieldType.input
    | FieldType.textarea
    | FieldType.date
    | FieldType.checkbox
    | FieldType.dateRange;
  key: string;
}

interface DateRange extends BaseConfig {
  type: FieldType.dateRange;
}

interface FormButton extends BaseConfig {
  type: FieldType.button;
}

interface QuestionAttachment extends BaseConfig {
  type: FieldType.attachment;
  acceptType: string;
  key: string;
}

interface QuestionDropDownAndRadioButton extends BaseConfig {
  type: FieldType.select | FieldType.radiobutton;
  options: Option[] | any;
  key: string;
}
interface QuestionInput extends BaseConfig {
  type: FieldType.input;
  inputType: string;
  key: string;
}
export type FieldConfig =
  | DateRange
  | DefaultQUestions
  | QuestionAttachment
  | QuestionInput
  | QuestionDropDownAndRadioButton
  | FormButton;

export enum FieldType {
  input = 'input',

  textarea = 'textarea',

  radiobutton = 'radiobutton',

  select = 'select',

  date = 'date',

  dateRange = 'dateRange',

  button = 'button',

  checkbox = 'checkbox',

  attachment = 'attachment',
}
